import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Card, Col, Row} from "react-bootstrap";
import {Trash} from "react-bootstrap-icons";
import FormRepeater from "../../../../../../../common/FormReapeater.jsx"
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import {useRegon} from "../../../../../../../../api/domain/regon/queries/useRegon.jsx";
import {toast} from 'react-toastify'

const RealizatorRow = ({wiz, row, setRow, idx, remove, parent}) => {
    const regonValue = row?.realizator_regon || ''
    const normalizedRegonValue = regonValue?.toString().trim()
    const regonTest = useRegon(regonValue, 'test')
    const regonData = useRegon(regonValue, 'data')
    const [regonState, setRegonState] = useState({
        checked: '',
        exists: false,
        ownerEmail: '',
        loading: false,
        error: '',
        missingPhone: false,
        missingEmail: false,
    })

    useEffect(() => {
        setRegonState((prev) => ({
            ...prev,
            checked: '',
            exists: false,
            ownerEmail: '',
            error: '',
            missingPhone: false,
            missingEmail: false,
        }))
    }, [regonValue])

    const resolveErrorMessage = (errors) => {
        if (!errors) return ''
        if (Array.isArray(errors?.regon)) return errors.regon[0]
        if (errors?.regon) return errors.regon
        if (Array.isArray(errors?.identyfikator)) return errors.identyfikator[0]
        if (errors?.identyfikator) return errors.identyfikator
        if (typeof errors === 'string') return errors
        return ''
    }

    const handleRegonTest = async () => {
        const regon = regonValue?.toString().trim()
        if (!regon) return
        setRegonState((prev) => ({...prev, loading: true}))
        const res = await regonTest.refetch()
        const data = res?.data
        const errorMessage = resolveErrorMessage(data?.errors)

        if (data?.status === 'failed' && data?.list?.length) {
            setRegonState({
                checked: regon,
                exists: false,
                ownerEmail: data?.list?.[0]?.email_wlasciciela || '',
                loading: false,
                error: '',
                missingPhone: false,
                missingEmail: false,
            })
            return
        }

        if (errorMessage) {
            toast.error(errorMessage)
            setRegonState({
                checked: regon,
                exists: false,
                ownerEmail: '',
                loading: false,
                error: errorMessage,
                missingPhone: false,
                missingEmail: false,
            })
            return
        }

        toast.success('REGON zweryfikowany pozytywnie.')
        setRegonState({
            checked: regon,
            exists: false,
            ownerEmail: '',
            loading: false,
            error: '',
            missingPhone: false,
            missingEmail: false,
        })
    }

    const handleRegonFetch = async () => {
        const regon = regonValue?.toString().trim()
        if (!regon) return
        setRegonState((prev) => ({...prev, loading: true}))
        const res = await regonData.refetch()
        const data = res?.data

        if (data?.status === 'success' && data?.list?.length) {
            const item = data.list[0]
            const nextForm = {
                ...wiz.form,
                [parent]: [...(wiz.form?.[parent] || [])],
            }
            nextForm[parent][idx] = {
                ...(nextForm[parent]?.[idx] || {}),
                realizator_nazwa: item?.nazwa || '',
                realizator_telefon: item?.telefon || '',
                realizator_email: item?.email || '',
            }
            wiz.setWizForm(nextForm)
            setRegonState((prev) => ({
                ...prev,
                checked: regon,
                exists: false,
                ownerEmail: '',
                error: '',
                missingPhone: !item?.telefon,
                missingEmail: !item?.email,
            }))
        }

        setRegonState((prev) => ({...prev, loading: false}))
    }

    const canFetch =
        normalizedRegonValue &&
        regonState.checked === normalizedRegonValue &&
        !regonState.exists &&
        !regonState.error

    // const showMissingPhone = regonState.missingPhone && !row?.realizator_telefon?.toString().trim()
    // const showMissingEmail = regonState.missingEmail && !row?.realizator_email?.toString().trim()

    return (
        <Card className={'d-flex flex-column gap-2 mb-3 w-100'} key={idx}>
            <Card.Header className={'d-flex justify-content-between align-items-center'}>
                <div className={'fw-bold'}>{`Podmiot ${idx+1}`}</div>
                <ButtonWithIcon
                    text={`Usuń podmiot ${idx+1}`}
                    onClick={() => remove(idx)}
                    icon={<Trash/>}
                    variant={'danger'}
                    className={'mt-4 align-self-start ms-auto'}
                />
            </Card.Header>
            <Card.Body className={'p-3'}>
                <Row>
                    <Col xs={12} md={3}>
                        <InputWiz
                            wiz={wiz}
                            keyName={`${parent}.${idx}.realizator_regon`}
                            row={row}
                            setRow={setRow}
                            idx={idx}
                            label={`I.2.1.${idx+1}.1 REGON`}
                        />
                    </Col>

                    <Col xs={12} md={3} className={'d-flex align-items-end'}>
                        <div className={'d-flex gap-1 mb-4'}>
                            <Button
                                size={'sm'}
                                variant={'info'}
                                disabled={regonState.loading || !normalizedRegonValue}
                                onClick={handleRegonTest}
                            >
                                Sprawdź REGON
                            </Button>
                            <Button
                                size={'sm'}
                                variant={'secondary'}
                                disabled={regonState.loading || !canFetch}
                                onClick={handleRegonFetch}
                            >
                                Pobierz z REGON
                            </Button>
                        </div>
                    </Col>

                    <Col xs={12} md={6}>
                        <InputWiz
                            wiz={wiz}
                            keyName={`${parent}.${idx}.realizator_nazwa`}
                            row={row}
                            setRow={setRow}
                            idx={idx}
                            label={`I.2.1.${idx+1}.2 Nazwa`}
                        />
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col xs={12} sm={6}>*/}
                {/*        <InputWiz*/}
                {/*            wiz={wiz}*/}
                {/*            keyName={`${parent}.${idx}.realizator_telefon`}*/}
                {/*            row={row}*/}
                {/*            setRow={setRow}*/}
                {/*            idx={idx}*/}
                {/*            label={`I.2.1.${idx+1}.3 Telefon realizatora`}*/}
                {/*        />*/}
                {/*        {showMissingPhone && (*/}
                {/*            <Alert variant={'warning'} className={'mt-1 mb-0'}>*/}
                {/*                W bazie REGON brak numeru telefonu. Uzupełnij pole ręcznie.*/}
                {/*            </Alert>*/}
                {/*        )}*/}
                {/*    </Col>*/}

                {/*    <Col xs={12} sm={6}>*/}
                {/*        <InputWiz*/}
                {/*            wiz={wiz}*/}
                {/*            keyName={`${parent}.${idx}.realizator_email`}*/}
                {/*            row={row}*/}
                {/*            setRow={setRow}*/}
                {/*            idx={idx}*/}
                {/*            label={`I.2.1.${idx+1}.4 Realizator email - pobierany z rejestru REGON`}*/}
                {/*        />*/}
                {/*        {showMissingEmail && (*/}
                {/*            <Alert variant={'warning'} className={'mt-1 mb-0'}>*/}
                {/*                W bazie REGON brak adresu e-mail. Uzupełnij pole ręcznie.*/}
                {/*            </Alert>*/}
                {/*        )}*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                <div className={'d-flex flex-column gap-2 mt-1'}>
                    {regonState.error && regonState.checked === normalizedRegonValue && (
                        <Alert variant={'danger'} className={'mb-0'}>
                            {regonState.error}
                        </Alert>
                    )}
                </div>
            </Card.Body>
        </Card>
    )
}

export const RealizatorzyRepeater = (props) => {
    const parent = props.parentListName || 'realizator_list'
    return (
        <FormRepeater
            value={props.wiz.form?.[parent] || []}
            onChange={(list) => props.wiz.setValue(parent, list)}
            length={JSON.stringify(props.wiz.form?.[parent] || []).split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0)}
            addButtonText="Dodaj podmiot"
            hideNativeDelete
            form={(row, setRow, idx, remove) => (
                <RealizatorRow
                    wiz={props.wiz}
                    row={row}
                    setRow={setRow}
                    idx={idx}
                    remove={remove}
                    parent={parent}
                />
            )}
        />
    )
}

RealizatorzyRepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string,
}
export default RealizatorzyRepeater
